module.exports = __webpack_public_path__ + "static/img/sec3-cont@m.8142598.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/design-samsung/sec3-cont@m.jpg
// module id = elBV
// module chunks = 0